/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type AdminNew_lists$ref = any;
export type AdminNewQueryVariables = {||};
export type AdminNewQueryResponse = {|
  +lists: ?{|
    +$fragmentRefs: AdminNew_lists$ref
  |}
|};
export type AdminNewQuery = {|
  variables: AdminNewQueryVariables,
  response: AdminNewQueryResponse,
|};
*/


/*
query AdminNewQuery {
  lists {
    ...AdminNew_lists
    id
  }
}

fragment AdminNew_lists on Lists {
  id
}
*/

const node/*: ConcreteRequest*/ = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminNewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Lists",
        "kind": "LinkedField",
        "name": "lists",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AdminNew_lists"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AdminNewQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Lists",
        "kind": "LinkedField",
        "name": "lists",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "AdminNewQuery",
    "operationKind": "query",
    "text": "query AdminNewQuery {\n  lists {\n    ...AdminNew_lists\n    id\n  }\n}\n\nfragment AdminNew_lists on Lists {\n  id\n}\n"
  }
};
// prettier-ignore
(node/*: any*/).hash = '34139f8ed5029c61a2a118daf94a5efe';

module.exports = node;
